import React, { useState } from "react";
import { Tooltip } from "antd";
import somethingWentWrong from "../../../../assets/No_Data_Found.svg";
import InfoIcon from "../../../../assets/Info_Icon.svg";
import { simpleKFormatterOnly } from "../../../../redux/constants";

const OverallTat = ({ id, overallTatwidget }) => {
  const [totalTicket, settotalTicket] = useState({
    text: "Show Details",
    toggle: false,
  });

  const showTicket = (e) => {
    if (e) {
      settotalTicket({ text: "Hide Details", toggle: true });
    } else {
      settotalTicket({ text: "Show Details", toggle: false });
    }
  };

  const secondsToDhms = (seconds) => {
    seconds = Number(seconds);
    var d = Math.floor(seconds / (3600 * 24));
    var h = Math.floor((seconds % (3600 * 24)) / 3600);
    var m = Math.floor((seconds % 3600) / 60);
    var s = Math.floor(seconds % 60);

    var dDisplay = d > 0 ? d + (d == 1 ? "D, " : "D, ") : "";
    var hDisplay = h > 0 ? h + (h == 1 ? "H, " : "H, ") : "";
    var mDisplay = m > 0 ? m + (m == 1 ? "M, " : "M, ") : "";
    var sDisplay = s > 0 ? s + (s == 1 ? "S" : "S") : "";
    return dDisplay + hDisplay + mDisplay + sDisplay;
  };

  return overallTatwidget?.data?.length > 0 ? (
    <>
      <div className="row ml-0 mr-0">
        <div className="col-12 col-md-6 text-center border-right">
          {id === "tickets_simple-view_3" || id === "tickets_simple-view_4" ? (
            <>
              <div className="wm-chart-card-title pt-15">
                {overallTatwidget?.data[0]?.data[1]?.text}
                {id === "tickets_simple-view_3" && (
                  <Tooltip
                    title="This is the average FLR calculated based on the tickets created in the selected duration and worked upon in the set working hours of the selected duration."
                    placement="bottom"
                  >
                    <img
                      src={InfoIcon}
                      alt="Info Icon"
                      className="ml-1 cursor-pointer"
                    />
                    {/* <i className="fa fa-question-circle ml-1" /> */}
                  </Tooltip>
                )}
                {id === "tickets_simple-view_4" && (
                  <Tooltip
                    title="This is the average TAT to closure calculated based on the tickets created in the selected duration and worked upon in the set working hours of the selected duration."
                    placement="bottom"
                  >
                    <img
                      src={InfoIcon}
                      alt="Info Icon"
                      className="ml-1 cursor-pointer"
                    />
                    {/* <i className="fa fa-question-circle ml-1" /> */}
                  </Tooltip>
                )}
              </div>
              <div className="blue-text mt-15">
                {overallTatwidget?.data[0]?.data[1]?.sub_title}
              </div>
              <div className="wm-chart-card-value pt-15 mb-15">
                {overallTatwidget?.data[0]?.data[1]?.value
                  ? secondsToDhms(overallTatwidget?.data[0]?.data[1]?.value)
                  : "0"}
              </div>
            </>
          ) : (
            <>
              <div className="wm-chart-card-title pt-15">
                {overallTatwidget?.data[0]?.text}
                {id === "tickets_simple-view_7" && (
                  <Tooltip
                    title="This is the average FLR based on tickets responded in working hours in the selected month"
                    placement="bottom"
                  >
                    <img
                      src={InfoIcon}
                      alt="Info Icon"
                      className="ml-1 cursor-pointer"
                    />
                    {/* <i className="fa fa-question-circle ml-1" /> */}
                  </Tooltip>
                )}
                {id === "tickets_simple-view_8" && (
                  <Tooltip
                    title="This is the average TAT to closure based on tickets closed in working hours of the selected month"
                    placement="bottom"
                  >
                    <img
                      src={InfoIcon}
                      alt="Info Icon"
                      className="ml-1 cursor-pointer"
                    />
                    {/* <i className="fa fa-question-circle ml-1" /> */}
                  </Tooltip>
                )}
              </div>
              <div className="blue-text mt-15">
                {overallTatwidget?.data[0]?.sub_title}
              </div>
              <div className="wm-chart-card-value pt-15 mb-15">
                {overallTatwidget?.data[0]?.value
                  ? secondsToDhms(overallTatwidget?.data[0]?.value)
                  : "0S"}
              </div>
            </>
          )}
          {/* Top Left Card */}

          {overallTatwidget?.data[0]?.data && (
            <div
              className={`row bg__grey-lightNew border-top ${
                totalTicket?.toggle &&
                (id !== "tickets_simple-view_7" ||
                  id !== "tickets_simple-view_8")
                  ? ""
                  : "d-none"
              }`}
            >
              <div className="col-12 col-md-6 text-center pr-0 pl-0">
                <div className="wm-chart-card-title pt-15">
                  {overallTatwidget?.data[0]?.data[0]?.text}
                  {id === "tickets_simple-view_3" && (
                    <Tooltip
                      title="This is the average FLR calculated based on the tickets created earlier than the selected duration but, worked upon in the set working hours of the selected duration."
                      placement="bottom"
                    >
                      <img
                        src={InfoIcon}
                        alt="Info Icon"
                        className="ml-1 cursor-pointer"
                      />
                      {/* <i className="fa fa-question-circle ml-1" /> */}
                    </Tooltip>
                  )}
                  {id === "tickets_simple-view_4" && (
                    <Tooltip
                      title="This is the average TAT to closure calculated based on the tickets created earlier than the selected duration but, worked upon in the selected duration."
                      placement="bottom"
                    >
                      <img
                        src={InfoIcon}
                        alt="Info Icon"
                        className="ml-1 cursor-pointer"
                      />
                      {/* <i className="fa fa-question-circle ml-1" /> */}
                    </Tooltip>
                  )}
                </div>
                <div className="blue-text mt-15">
                  {overallTatwidget?.data[0]?.data[0]?.sub_title}
                </div>
                <div className="wm-chart-card-value pt-15 mb-15">
                  <Tooltip
                    title={
                      overallTatwidget?.data[0]?.data[0]?.value
                        ? id !== "tickets_simple-view_3" &&
                          id !== "tickets_simple-view_4"
                          ? overallTatwidget?.data[0]?.data[0]?.value?.toLocaleString()
                          : ""
                        : "0"
                    }
                    placement="bottom"
                  >
                    {overallTatwidget?.data[0]?.data[0]?.value
                      ? id === "tickets_simple-view_3" ||
                        id === "tickets_simple-view_4"
                        ? secondsToDhms(
                            overallTatwidget?.data[0]?.data[0]?.value
                          )
                        : simpleKFormatterOnly(
                            overallTatwidget?.data[0]?.data[0]?.value
                          )
                      : "0"}
                  </Tooltip>
                </div>

                {/* 1st Card */}
              </div>
              <div className="col-12 col-md-6 border-left text-center pr-0 pl-0">
                <div className="wm-chart-card-title pt-15">
                  {overallTatwidget?.data[0]?.text}
                  {id === "tickets_simple-view_3" && (
                    <Tooltip
                      title="This is the average FLR calculated based on all the tickets worked upon in the selected duration."
                      placement="bottom"
                    >
                      <img
                        src={InfoIcon}
                        alt="Info Icon"
                        className="ml-1 cursor-pointer"
                      />
                      {/* <i className="fa fa-question-circle ml-1" /> */}
                    </Tooltip>
                  )}
                  {id === "tickets_simple-view_4" && (
                    <Tooltip
                      title="This is the average TAT to closure calculated based on all the tickets worked upon in the selected duration."
                      placement="bottom"
                    >
                      <img
                        src={InfoIcon}
                        alt="Info Icon"
                        className="ml-1 cursor-pointer"
                      />
                      {/* <i className="fa fa-question-circle ml-1" /> */}
                    </Tooltip>
                  )}
                </div>
                <div className="blue-text mt-15">
                  {overallTatwidget?.data[0]?.sub_title}
                </div>
                <div className="wm-chart-card-value pt-15 mb-15">
                  {overallTatwidget?.data[0]?.value
                    ? secondsToDhms(overallTatwidget?.data[0]?.value)
                    : "0S"}
                </div>
                {/* @nd Card */}
              </div>
            </div>
          )}
        </div>
        <div className="col-12 col-md-6 text-center">
          {id === "tickets_simple-view_3" || id === "tickets_simple-view_4" ? (
            <>
              <div className="wm-chart-card-title pt-15">
                {overallTatwidget?.data[1]?.data[1]?.text}
                {id === "tickets_simple-view_3" && (
                  <Tooltip
                    title="This is the average FLR calculated based on the tickets created in the selected duration and worked upon irrespective of the set working hours."
                    placement="bottom"
                  >
                    <img
                      src={InfoIcon}
                      alt="Info Icon"
                      className="ml-1 cursor-pointer"
                    />
                    {/* <i className="fa fa-question-circle ml-1" /> */}
                  </Tooltip>
                )}
                {id === "tickets_simple-view_4" && (
                  <Tooltip
                    title="This is the overall TAT to closure calculated based on the tickets created in the selected duration and worked upon irrespective of the set working hours."
                    placement="bottom"
                  >
                    <img
                      src={InfoIcon}
                      alt="Info Icon"
                      className="ml-1 cursor-pointer"
                    />
                    {/* <i className="fa fa-question-circle ml-1" /> */}
                  </Tooltip>
                )}
              </div>
              <div className="blue-text mt-15">
                {overallTatwidget?.data[1]?.data[1]?.sub_title}
              </div>
              <div className="wm-chart-card-value pt-15 mb-15">
                {overallTatwidget?.data[1]?.data[1]?.value
                  ? secondsToDhms(overallTatwidget?.data[1]?.data[1]?.value)
                  : "0"}
              </div>
            </>
          ) : (
            <>
              <div className="wm-chart-card-title pt-15">
                {overallTatwidget?.data[1]?.text}
                {id === "tickets_simple-view_7" && (
                  <Tooltip
                    title="This is the average FLR based on tickets responded in the selected month irrespective of the working hours"
                    placement="bottom"
                  >
                    <img
                      src={InfoIcon}
                      alt="Info Icon"
                      className="ml-1 cursor-pointer"
                    />
                    {/* <i className="fa fa-question-circle ml-1" /> */}
                  </Tooltip>
                )}
                {id === "tickets_simple-view_8" && (
                  <Tooltip
                    title="This is the overall TAT to closure based on tickets closed in the selected month"
                    placement="bottom"
                  >
                    <img
                      src={InfoIcon}
                      alt="Info Icon"
                      className="ml-1 cursor-pointer"
                    />
                    {/* <i className="fa fa-question-circle ml-1" /> */}
                  </Tooltip>
                )}
              </div>
              <div className="blue-text mt-15">
                {overallTatwidget?.data[1]?.sub_title}
              </div>
              <div className="wm-chart-card-value pt-15 mb-15">
                {overallTatwidget?.data[1]?.value
                  ? secondsToDhms(overallTatwidget?.data[1]?.value)
                  : "0S"}
              </div>
            </>
          )}
          {/* Top Right Card */}
          {overallTatwidget?.data[1]?.data && (
            <div
              className={`row border-top bg__grey-lightNew ${
                totalTicket?.toggle &&
                (id !== "tickets_simple-view_7" ||
                  id !== "tickets_simple-view_8")
                  ? ""
                  : "d-none"
              }`}
            >
              <div className="col-12 col-md-6 text-center">
                <div className="wm-chart-card-title pt-15">
                  {overallTatwidget?.data[1]?.data[0]?.text}
                  {id === "tickets_simple-view_3" && (
                    <Tooltip
                      title="This is the average FLR calculated based on the tickets created earlier than the selected duration but, worked upon in the selected duration."
                      placement="bottom"
                    >
                      <img
                        src={InfoIcon}
                        alt="Info Icon"
                        className="ml-1 cursor-pointer"
                      />
                      {/* <i className="fa fa-question-circle ml-1" /> */}
                    </Tooltip>
                  )}
                  {id === "tickets_simple-view_4" && (
                    <Tooltip
                      title="This is the overall TAT to closure calculated based on the tickets created earlier than the selected duration but, worked upon in the selected duration."
                      placement="bottom"
                    >
                      <img
                        src={InfoIcon}
                        alt="Info Icon"
                        className="ml-1 cursor-pointer"
                      />
                      {/* <i className="fa fa-question-circle ml-1" /> */}
                    </Tooltip>
                  )}
                </div>
                <div className="blue-text mt-15">
                  {" "}
                  {overallTatwidget?.data[1]?.data[0]?.sub_title}
                </div>
                <div className="wm-chart-card-value pt-15 mb-15">
                  <Tooltip
                    title={
                      overallTatwidget?.data[1]?.data[0]?.value
                        ? id !== "tickets_simple-view_3" &&
                          id !== "tickets_simple-view_4"
                          ? overallTatwidget?.data[1]?.data[0]?.value?.toLocaleString()
                          : ""
                        : "0"
                    }
                    placement="bottom"
                  >
                    {overallTatwidget?.data[1]?.data[0]?.value
                      ? id === "tickets_simple-view_3" ||
                        id === "tickets_simple-view_4"
                        ? secondsToDhms(
                            overallTatwidget?.data[1]?.data[0]?.value
                          )
                        : simpleKFormatterOnly(
                            overallTatwidget?.data[1]?.data[0]?.value
                          )
                      : "0"}
                  </Tooltip>
                </div>
                {/* 3rd Card */}
              </div>
              <div className="col-12 col-md-6 border-left text-center">
                <div className="wm-chart-card-title pt-15">
                  {overallTatwidget?.data[1]?.text}
                  {id === "tickets_simple-view_3" && (
                    <Tooltip
                      title="This is the average FLR calculated based on all the tickets worked upon in the selected duration irrespective of the working hours."
                      placement="bottom"
                    >
                      <img
                        src={InfoIcon}
                        alt="Info Icon"
                        className="ml-1 cursor-pointer"
                      />
                      {/* <i className="fa fa-question-circle ml-1" /> */}
                    </Tooltip>
                  )}
                  {id === "tickets_simple-view_4" && (
                    <Tooltip
                      title="This is the overall TAT to closure calculated based on all the tickets worked upon in the selected duration."
                      placement="bottom"
                    >
                      <img
                        src={InfoIcon}
                        alt="Info Icon"
                        className="ml-1 cursor-pointer"
                      />
                      {/* <i className="fa fa-question-circle ml-1" /> */}
                    </Tooltip>
                  )}
                </div>
                <div className="blue-text mt-15">
                  {overallTatwidget?.data[1]?.sub_title}
                </div>
                <div className="wm-chart-card-value pt-15 mb-15">
                  {overallTatwidget?.data[1]?.value
                    ? secondsToDhms(overallTatwidget?.data[1]?.value)
                    : "0S"}
                </div>

                {/* 4th Card */}
              </div>
            </div>
          )}
        </div>
      </div>
      {id === "tickets_simple-view_7" || id === "tickets_simple-view_8" ? (
        ""
      ) : (
        <div
          className="text_regular showTicket border-top cursor-pointer text-center pt-15 pb-15"
          onClick={() => showTicket(!totalTicket?.toggle)}
        >
          {totalTicket?.text}
        </div>
      )}
    </>
  ) : (
    <div className="portlet_images text-center p-15">
      <img
        alt="no data"
        src={somethingWentWrong}
        style={{ maxWidth: "100%", minWidth: "20rem", marginTop: "1.5rem" }}
      />
      <p className="mt-15 text_regular-gray">No Data Found</p>
    </div>
  );
};

export default OverallTat;
